import { React, useEffect, useState } from "react";
import "./WeeklyTargets.css";
import {
  Col,
  DatePicker,
  Row,
  InputNumber,
  Tag,
} from "antd";
import { calendar2 } from "../../../Utils/imports";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { CheckCircleFilled } from "../../../Utils/imports";
import { useDispatch, useSelector } from "react-redux";
import { updateTarget } from "../../../API-Interaction/apiServices/productionLine.api";

const WeeklyTargets = () => {
  const dispatch = useDispatch()
  const { current } = useSelector((state) => state?.plant);
  const getCurrentWeekMonthYear = () => {
    const currentDate = new Date();
    const currentWeek = Math.ceil(
      (currentDate.getDate() +
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay()) /
        7
    );
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    return { currentWeek, currentMonth, currentYear };
  };
  const { currentWeek, currentMonth, currentYear } = getCurrentWeekMonthYear();
  const [selectedDays, setSelectedDays] = useState([]);
  const [weeklyTarget, setWeeklyTarget] = useState(0);
  const handleWeekTargetChange = (value) => {
    setWeeklyTarget(value);
  };
  const yearToWeek = currentYear + "-" + currentWeek;

  let targets =
    current?.machine && current?.machine?.weeklyTargets
      ? current?.machine.weeklyTargets[yearToWeek]
      : current?.line?.weeklyTargets
      ? current?.line?.weeklyTargets[yearToWeek]
      : null;
  // let totalTargetValue = targets.totalTargetValue;
  // console.log(totalTargetValue, yearToWeek);

  if (targets != null) {
    let dict = {};
    let selectedDaysX = [];
    // let totalTargetValue = targets.targetValue
    targets.map((target) => {
      if (target["day"]) {
        dict[target["day"]] = target.value;
        selectedDaysX.push(target["day"]);
      }
      // if (target["totalTargetValue"])
      //   totalTargetValue = target["totalTargetValue"];
    });
      // selectedDays = selectedDaysX;
    dict = dict;
    // detailsBefore =  JSON.parse(JSON.stringify(dict))
  }

  const handleDayClick = (day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(
        selectedDays.filter((selectedDay) => selectedDay !== day)
      );
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };
  // useEffect(() => {
  //   console.log("Selected Days:", selectedDays);
  // }, [selectedDays]);

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const updateTargets = (e) => {
    console.log('Selected Days: ', selectedDays, 'Weekly Target: ', weeklyTarget)
    // const { dispatch, line, currentShift, machine, currentUser, plant } =
    //   current;
    // let selectedDaysLength = selectedDays.length;
    // let perDayTarget = totalTargetValue / selectedDaysLength;
    // let targets = [];
    // for (let x = 0; x < selectedDaysLength; x++) {
    //   let temp = {
    //     value: perDayTarget,
    //     day: selectedDays[x],
    //     updated_at: new Date(),
    //   };
    //   targets.push(temp);
    // }
    // console.log(targets);
    // targets.push({ totalTargetValue: totalTargetValue });

    // let data = {};
    // if (machine) {
    //   line.machines.map((x) => {
    //     if (x.machineName == machine.machineName) {
    //       x.weeklyTargets = x.weeklyTargets ? x.weeklyTargets : null;
    //       if (x.weeklyTargets != null) {
    //         x.weeklyTargets[yearToWeek] = targets;
    //       } else x.weeklyTargets = {};
    //       x.weeklyTargets[yearToWeek] = targets;
    //     }
    //   });
    //   data = {
    //     machines: line.machines,
    //   };
    // } else {
    //   line.weeklyTargets = line.weeklyTargets ? line.weeklyTargets : null;
    //   if (line.weeklyTargets != null) {
    //     data = line.weeklyTargets;
    //     line.weeklyTargets[yearToWeek] = targets;
    //     data = { weeklyTargets: line.weeklyTargets };
    //   } else {
    //     data.weeklyTargets = {};
    //     data.weeklyTargets[this.state.yearToWeek] = targets;
    //   }
    // }
    // console.log(
    //   line,
    //   plant,
    //   machine,
    //   currentShift,
    //   currentUser,
    //   { ...data },
    //   "targets"
    // );

    // updateTarget({
    //   dispatch,
    //   type: 'line/update',
    //   payload: {
    //     id: line.id,
    //     data,
    //     log
    //   },
    // });
    // emailOnLineSettingsChange({
    //     line,
    //     type: 'weekly-targets-change',
    //     currentShift,
    //     machine: machine ? machine.machineName : null,
    //   })
  };

  return (
    <>
      <Row gutter={24} className="pt1">
        <Col span={7} className="dflex">
          <h1 className="pageHead">Weekly Targets</h1>
        </Col>
        <Col span={8} style={{ paddingTop: "3px" }}>
          <div className="dflex justifyFE">
            <Tag className="weekTag dflex justifyCenter alignCenter">
              {`Week:`}
              <strong>
                {currentWeek}
                {"\u00A0"}
              </strong>
              {` Month:`}
              <strong>
                {currentMonth}
                {"\u00A0"}
              </strong>
              {` Year:`}
              <strong>{currentYear}</strong>
              <img src={calendar2} alt="Calendar" className="weekImg" />
            </Tag>
          </div>
        </Col>
      </Row>
      <span>Please Select Shift Days</span>
      <Row gutter={24}>
        <Col span={15}>
          <div className="pt10">
            {daysOfWeek.map((day) => (
              <Tag
                key={day}
                className="weekdays"
                onClick={() => handleDayClick(day)}
                style={
                  selectedDays.includes(day)
                    ? { border: "1px solid #1E6EFE", color: "#1E6EFE" }
                    : null
                }
              >
                {day}
              </Tag>
            ))}
          </div>
          <div className="pt20">
            <span>Enter Weekly Target</span>
          </div>
          <div className="pt20">
            <InputNumber
              style={{ height: "35px" }}
              className="boxBorderRad width100P"
              placeholder={"Target"}
              type="number"
              value={weeklyTarget}
              onChange={handleWeekTargetChange}
            />
          </div>
          <div
            className="width100P dflex alignCenter justifyFE"
            style={{ paddingTop: "20px" }}
          >
            <ButtonComp
              htmlType="submit"
              theme="blue"
              icon={<CheckCircleFilled />}
              text="Ok"
              onClick={updateTargets}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};
export default WeeklyTargets;
